// Domain and API contract types are shared with the server — see shared/types/.
// Only client-side (UI/derived) types live in this file.
export * from '../../shared/types/index.js';

import type { LatLngTuple, Site } from '../../shared/types/index.js';

export const ZONE_TYPES = [
  { value: 'syn', icon: '🕍' },
  { value: 'school', icon: '🏫' },
  { value: 'community', icon: '🏛' },
  { value: 'memorial', icon: '🕯' },
];

export type PositionStatus = 'breach' | 'inzone' | 'approach' | 'flagged';

/** Live, client-derived state of a suspect relative to its nearest protected site. */
export interface Position {
  lat: number;
  lng: number;
  trail: Array<LatLngTuple>;
  score: number;
  nearDist: number;
  nearLoc?: Site;
  perimeterIdx?: number;
  status: PositionStatus;
}

export interface Alert {
  t: string;
  time: string;
  title: string;
  body: string;
  loc: string;
  sus: string;
}

export interface TickerItem {
  t: 'c' | 'i' | 'w' | 's';
  text: string;
}
